import { CurrencyEuroIcon, UserIcon } from "@heroicons/react/20/solid";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

const InvalidPermissions = ({ year }) => {
	return (
		<div
			className="block text-center bg-white"
			style={{ paddingTop: 120 }}
		>
			<div id="all-done">
				<div
					className="item item-circle bg-primary"
					style={{ position: "relative", height: "12rem", width: "12rem" }}
				>
					<UserIcon
						style={{ position: "absolute", height: "10rem", color: "white", right: "1rem", top: "1rem" }}
					/>
					<CurrencyEuroIcon
						style={{
							position: "absolute",
							height: "5rem",
							color: "#ea611c",
							right: "0rem",
							top: "6rem",
							background: "white",
							borderRadius: "5rem",
						}}
					/>
				</div>
				<div className="main">
					<h1 className="font-w700 text-center">Cost of Living {year}</h1>
					<h4 className="text-center">It seems that you still need to update your employees' wages.</h4>
					<p className="text-center">
						By Maltese law, you are legally required to increase your employees' wages by the minimum amount
						dictated by Cost of Living Adjustments (COLA)
					</p>
					<p className="text-center">
						<a
							target="_blank"
							href="https://support.buddy.hr/hc/en-mt/articles/360018705179-Adding-the-Annual-Cost-Of-Living-Adjustment-COLA-"
						>
							Learn More Here
						</a>{" "}
						or <Link to="/organisation/people">Review in People Page</Link>
					</p>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
    return {}
}

const mapDispatchToProps = dispatch => ({
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InvalidPermissions)